import * as React from 'react';

interface IImageTextProps {
    type?: string;
    img: string;
    children: any;
}

const ImageText = (props: IImageTextProps) => {
    const {type, img, children} = props;
    return (
        <div className={'imageText' + (type ? ' imageText--' + type : '')}>
            <img src={img} className="imageText__img" />
            <div className="imageText__content">
                {children}
            </div>
        </div>
    );
};

export default ImageText;



// WEBPACK FOOTER //
// ./src/modules/ImageText/ImageText.tsx